'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import XMarkIcon from '@flipster/react/icon/generated/XMarkIcon';
import { useBreakpoint } from '@flipster/react/misc/responsive';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import segment from '@flipster/utils/segment';
import { EarnEvent } from '@flipster/utils/segment/events/earn';

import Marquee from './Marquee';
import { fomoBannerBunja } from './bunja';

const FomoBanner = () => {
  const { fomoBannerReadyAtom, tradeTabTextAtom, filteredExchangeWinnersAtom, closeFomoBanner } =
    useBunja(fomoBannerBunja);

  const { isMobile } = useBreakpoint();
  const tradeTabText = useAtomValue(tradeTabTextAtom);
  const isFomoBannerOpened = useAtomValue(fomoBannerReadyAtom);
  const filteredExchangeWinnersData = useAtomValue(filteredExchangeWinnersAtom);
  const handleFomoBannerClose = () => {
    closeFomoBanner();
    segment.track(EarnEvent.PnlBannerCloseClick, { page_type: 'trade_page' });
  };
  const isSpotOnly = useCheckSpotOnly();

  if (!isFomoBannerOpened || isMobile || isSpotOnly) return null;

  return (
    <section
      className={css({
        zIndex: 101, // orderform button zindex가 100
        gridArea: 'fomo-banner',
        pos: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        pt: 'var(--grid-space)',
        bgColor: 'gray.black',
      })}
    >
      <div
        className={flex({
          h: 'var(--fomo-banner-height)',
          bgColor: 'background.default.level-0',
          align: 'center',
          '&::before': {
            pos: 'absolute',
            right: '0',
            top: '50%',
            content: "''",
            w: 16,
            h: 48,
            transform: 'translateY(-50%)',
            bgColor: 'background.default.level-0',
            zIndex: 1,
          },
          '&::after': {
            pos: 'absolute',
            right: '16px',
            top: '50%',
            content: "''",
            w: 80,
            h: 48,
            background: 'linear-gradient(90deg, #111111 0%, rgba(42, 42, 42, 0) 100%)',
            transform: 'translateY(-50%) rotate(-180deg)',
          },
        })}
      >
        <div
          className={css({
            textStyle: 'Text/L/Regular',
            flex: 'none',
            px: 24,
            color: 'content.default.level-5',
          })}
        >
          {tradeTabText}
        </div>
        <div className={css({ pr: 16 })}>
          <Marquee winners={filteredExchangeWinnersData} />
        </div>
        <button
          type='button'
          className={css({
            pos: 'absolute',
            right: 16,
            zIndex: 1,
          })}
          onClick={handleFomoBannerClose}
        >
          <XMarkIcon size={24} color={token('colors.inverse.white')} />
        </button>
      </div>
    </section>
  );
};

export default FomoBanner;
